import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

const CTASection = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const features = [
    { en: 'Verified Data', ar: 'بيانات موثقة' },
    { en: 'Strategic Analysis', ar: 'تحليل استراتيجي' },
    { en: 'Honest Risk Assessment', ar: 'تقييم صادق للمخاطر' }
  ];

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/31566720/pexels-photo-31566720.jpeg?w=1920&q=85)'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#12532c]/95 via-[#12532c]/90 to-[#12532c]/95" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          {t({
            en: 'Ready for Strategic Investment Intelligence?',
            ar: 'هل أنت مستعد للمعلومات الاستثمارية الاستراتيجية؟'
          })}
        </h2>
        <p className="text-xl text-emerald-100 mb-8 max-w-2xl mx-auto">
          {t({
            en: 'Access institutional-grade Dubai real estate intelligence. No sales pitches. No glossy brochures. Just verified data, honest risk assessment, and investment logic.',
            ar: 'احصل علمعلومات عقارات دبي بجودة مؤسسية. بدون عروض ترويجية. فقط بيانات موثقة وتقييم صادق للمخاطر.'
          })}
        </p>

        {/* Features List */}
        <div className="flex flex-wrap justify-center gap-6 mb-10">
          {features.map((feature, idx) => (
            <div key={idx} className="flex items-center space-x-2 text-white">
              <CheckCircle2 className="w-5 h-5 text-emerald-400" />
              <span className="text-lg">{t(feature)}</span>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            onClick={() => navigate('/contact')}
            className="bg-[#C5A038] text-white hover:bg-[#b08f2f] text-lg px-10 py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 font-semibold"
          >
            {t({ en: 'Book Strategic Consultation', ar: 'احجز استشارة استراتيجية' })}
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => navigate('/services')}
            className="border-2 border-white text-white hover:bg-white hover:text-[#12532c] text-lg px-10 py-6 rounded-lg backdrop-blur-sm transition-all duration-300 font-semibold"
          >
            {t({ en: 'Explore Services', ar: 'استكشف الخدمات' })}
          </Button>
        </div>

        <p className="text-emerald-200 mt-6 text-sm">
          {t({
            en: '30-minute diagnostic session • No obligation • No sales pitch',
            ar: 'جلسة تشخيصية 30 دقيقة • بدون التزام • بدون عروض ترويجية'
          })}
        </p>
      </div>
    </section>
  );
};

export default CTASection;
